/* Ability Warehouse — shared Quick-view (v33).
   One implementation used by the buying-guide product cards (snippets/guide-product-card.liquid) and the fit-check
   alternatives (assets/aw-fit-result.js). A trigger is any element with data-quickview="<product-handle>", optionally
   data-qv-spec="…" (a line or two of key specs) and data-qv-img="…" (a thumbnail to show while the full data loads).
   Opens as a bottom-sheet modal on mobile and a slide-in side panel on desktop (styling in assets/aw-quickview.css).
   Add to cart goes through the theme's window.CWCart (count bump) with a /cart/add.js fallback — no page reload. */
(function () {
  'use strict';
  if (window.AWQuickView) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var n = (Math.round(+cents || 0) / 100);
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function CW() { return window.CW || {}; }
  function memberPct() { var p = +CW().memberPct; return p > 0 ? p : 10; }
  function isMember() { return !!CW().member; }
  function noSale(prod) { var t = prod.tags || []; return t.indexOf('no-sale') > -1 || t.indexOf('supplier-dearjane') > -1; }
  function sized(src, w) { if (!src) return ''; return /(\?|&)width=/.test(src) ? src.replace(/width=\d+/, 'width=' + w) : src.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$2'); }

  var cache = {};
  function productJS(handle) {
    return cache[handle] || (cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }));
  }
  function bumpCount(n) {
    document.querySelectorAll('.header__cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var c = a.querySelector('.header__count');
      if (!c) { c = document.createElement('span'); c.className = 'header__count'; a.appendChild(c); }
      c.textContent = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
  }

  /* one shared overlay element, reused for every open */
  var el = null, lastFocus = null, cur = null;
  function build() {
    el = document.createElement('div');
    el.className = 'awqv';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Quick view');
    el.innerHTML = '<div class="awqv__backdrop" data-qv-close></div>' +
      '<div class="awqv__panel" role="document"><div class="awqv__grip" aria-hidden="true"></div>' +
      '<button type="button" class="awqv__x" data-qv-close aria-label="Close quick view">×</button>' +
      '<div class="awqv__scroll" data-qv-scroll></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) close(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(el.querySelectorAll('button:not([disabled]),a[href],select,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return el;
  }
  function lock(on) { try { document.documentElement.style.overflow = on ? 'hidden' : ''; } catch (e) {} }
  function close() {
    if (!el) return;
    el.classList.remove('is-open');
    lock(false);
    cur = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function priceBlock(prod, variant) {
    var price = variant.price, ns = noSale(prod);
    var mem = ns ? price : Math.round(price * (100 - memberPct()) / 100);
    var pays = isMember() && !ns ? mem : price;
    var h = '<div class="awqv__price"><span class="awqv__now" data-qv-now>' + money(pays) + '</span>';
    // strikethrough ONLY for the member-price comparison (store rule)
    if (isMember() && !ns && mem < price) h += '<s class="awqv__was" data-qv-was>' + money(price) + '</s>';
    else if (!ns && mem < price) h += '<span class="awqv__mem" data-qv-mem>Members <b>' + money(mem) + '</b></span>';
    h += '</div>';
    return h;
  }
  function render(prod, opts) {
    var scroll = el.querySelector('[data-qv-scroll]');
    var variants = prod.variants || [];
    var v = variants.filter(function (x) { return x.available; })[0] || variants[0] || { price: prod.price, id: prod.id };
    cur = { prod: prod, vid: v.id };
    var img = (v.featured_image && v.featured_image.src) || prod.featured_image || opts.img || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var brand = (prod.vendor && prod.vendor !== 'Ability Warehouse') ? prod.vendor : '';
    var specs = (opts.spec || '').split(/\s*·\s*|\s*·\s*|\n/).map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 3);
    var multi = variants.length > 1;
    var h = '';
    h += '<span class="awqv__media">' + (img ? '<img src="' + esc(sized(img, 640)) + '" alt="" width="640" height="480" data-qv-img>' : '') + '</span>';
    if (brand) h += '<span class="awqv__brand">' + esc(brand) + '</span>';
    h += '<h2 class="awqv__title" id="awqv-title">' + esc(prod.title) + '</h2>';
    if (specs.length) h += '<ul class="awqv__specs">' + specs.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul>';
    h += '<div data-qv-pricewrap>' + priceBlock(prod, v) + '</div>';
    if (multi) {
      var nm = (prod.options && prod.options.length === 1 ? prod.options[0] : 'Option');
      h += '<label class="awqv__var"><span>' + esc(nm) + '</span><select data-qv-var>' + variants.map(function (x) {
        return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' — sold out') + '</option>';
      }).join('') + '</select></label>';
    }
    h += '<p class="awqv__oos" data-qv-oos' + (v.available ? ' hidden' : '') + '>Currently out of stock</p>';
    h += '<button type="button" class="awqv__add" data-qv-add' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Add to cart' : 'Sold out') + '</button>';
    h += '<div class="awqv__toast" data-qv-msg hidden></div>';
    h += '<div class="awqv__links"><a href="' + esc(prod.url) + '"><b>View full details</b></a>' +
      '<a href="' + esc(prod.url) + '" target="_blank" rel="noopener">Open product page in new tab <span aria-hidden="true">↗</span></a></div>';
    h += '<p class="awqv__note">Prices include everything you pay. Guidance only — call (02) 9125 4293 if you’d like help choosing.</p>';
    scroll.innerHTML = h;
    el.setAttribute('aria-labelledby', 'awqv-title');
  }
  function syncVariant() {
    if (!cur) return;
    var sel = el.querySelector('[data-qv-var]'); if (!sel) return;
    var v = cur.prod.variants.filter(function (x) { return String(x.id) === String(sel.value); })[0]; if (!v) return;
    cur.vid = v.id;
    el.querySelector('[data-qv-pricewrap]').innerHTML = priceBlock(cur.prod, v);
    var img = (v.featured_image && v.featured_image.src) || '', imEl = el.querySelector('[data-qv-img]');
    if (img && imEl) { if (img.indexOf('//') === 0) img = 'https:' + img; imEl.src = sized(img, 640); }
    var oos = el.querySelector('[data-qv-oos]'), add = el.querySelector('[data-qv-add]');
    if (oos) oos.hidden = v.available;
    if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to cart' : 'Sold out'; add.classList.remove('is-added'); }
  }
  function add() {
    if (!cur) return;
    var btn = el.querySelector('[data-qv-add]'), msg = el.querySelector('[data-qv-msg]');
    if (!btn || btn.disabled) return;
    btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
    var C = window.CWCart, payload = { items: [{ id: +cur.vid, quantity: 1 }] };
    if (C && C.sections) payload.sections = C.sections();
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sorry, that could not be added.');
        var done = function () {
          btn.classList.add('is-added'); btn.textContent = 'Added ✓';
          if (msg) { msg.innerHTML = '<span aria-hidden="true">✓</span> Added to your cart <button type="button" class="awqv__linkbtn" data-qv-cart style="margin-left:auto;background:none;border:0;color:inherit;font:inherit;font-weight:800;text-decoration:underline;cursor:pointer">View cart</button>'; msg.hidden = false; }
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 2400);
        };
        if (C && C.apply && res.j.sections) return C.apply(res.j.sections).catch(function () {}).then(done);
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { bumpCount(c.item_count); }).catch(function () {}).then(done);
      })
      .catch(function (err) {
        btn.textContent = label; btn.disabled = false;
        if (msg) { msg.style.background = '#FCECEC'; msg.style.color = '#B01017'; msg.textContent = err.message || 'Sorry, that could not be added.'; msg.hidden = false; }
      });
  }

  function open(handle, opts) {
    if (!handle) return;
    opts = opts || {};
    if (!el) build();
    lastFocus = document.activeElement;
    lock(true);
    el.classList.add('is-open');
    var scroll = el.querySelector('[data-qv-scroll]');
    scroll.innerHTML = '<div class="awqv__loading">Loading…</div>';
    var x = el.querySelector('.awqv__x'); if (x) x.focus({ preventScroll: true });
    productJS(handle).then(function (prod) {
      if (!el.classList.contains('is-open')) return;
      render(prod, opts);
      var add1 = el.querySelector('[data-qv-add]'); if (add1) add1.focus({ preventScroll: true });
    }).catch(function () {
      scroll.innerHTML = '<div class="awqv__loading">Sorry — this couldn’t load. <a href="/products/' + esc(handle) + '">Open the product page</a>.</div>';
    });
  }

  el = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quickview]');
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var handle = t.getAttribute('data-quickview');
    if (!handle) return;
    e.preventDefault();
    open(handle, { spec: t.getAttribute('data-qv-spec') || '', img: t.getAttribute('data-qv-img') || '' });
  });
  document.addEventListener('click', function (e) {
    if (!el || !el.classList.contains('is-open')) return;
    if (e.target.closest('[data-qv-cart]') && window.CWCart && window.CWCart.open) { window.CWCart.open(); }
  });
  document.addEventListener('change', function (e) { if (el && e.target.closest && e.target.matches('[data-qv-var]')) syncVariant(); });

  window.AWQuickView = { open: open, close: close };
})();
